<!-- <div class="flex-row full column align-start position-relative">
  <div class="flex-row full column align-center p-15">
    <img src="assets/new-assets/icons/icon-enter-investment-detail.svg" class="mb-30" alt="">
    <p class="fs-20 fw-6 text-dark mb-16">Complete your Risk Profiling</p>
    <p class="fs-14 mb-16 text-center">As per SEBI guidelines, it is mandatory to
      complete the risk profiling before investing</p>
    <button type="button" class="btn btn-primary width-100-pr" (click)="gotoRiskProfile()">Complete Now</button>
  </div>
</div> -->


<!-- new popup -->
<div class="flex-row full align-start position-relative content-between height-100-pr">
  <button type="button" class="btn color-secondary close-modal" (click)="close(false)"><img
      src="assets/new-assets/icons/icon-close-black.svg" alt="Go back" class="height-15-px width-15-px"></button>
  <div class="flex-row align-center height-100-pr">
    <div class=" full align-center mr-5 bg-secondary height-100-pr flex-row">
      <img src="assets/new-assets/illustrations/riskprofile-popup.svg" alt="Risk profile" class="flex ">
    </div>
    <div class="p-30">
      <h1 mat-dialog-title class="fs-22 ml-10 fw-7">Customizing the best experience for you</h1>
      <div mat-dialog-content class="fs-14 fw-6  mr-5 ml-10 mt-20">We got to follow the head - SEBI &nbsp; Regulation’s
        for your risk profiling. Financial Advices are on the way once you say okay.</div>
      <div mat-dialog-actions class="column mt-40">
        <button type="button" class="btn btn-primary width-100-pr" routerLink="/profile-completion"
          (click)="gotoRiskProfile()">I don't mind,Start</button>
      </div>
    </div>
  </div>
</div>